import classNames from 'classnames';
import { graphql, useStaticQuery } from 'gatsby';
import { useI18next } from 'gatsby-plugin-react-i18next';
import React from 'react';

export interface BrandObject {
  src: string;
  filter?: boolean;
  alt?: string;
  onClick?: () => void;
}

interface BrandProps {
  brandsList?: BrandObject[];
  center?: boolean;
  className?: string;
}

const Brands: React.FC<BrandProps> = props => {
  // brandsList is an array of objects with 2 properties - src and filter. if filter is true -> grayscale is applied.
  // eg: brandsList = [{src: <Cartograph/>, filter: false}, {src: <Pmg/>, filter: true}]
  const { brandsList, center, className } = props;
  const { language } = useI18next();

  const pageQuery = useStaticQuery(graphql`
    query {
      brandsEN: allContentfulAsset(
        filter: {
          contentful_id: {
            in: [
              "5ZHwRCJIK6a9tkjBsrmOnd"
              "6EHfHinEYSnC23RMoYq865"
              "5NTfMLN6uirazhT946u4Ac"
              "4r0NGBmSYne0mSyug2D8hp"
              "3ap5LJFcDEaMDxFit7jhV9"
              "32WNQLMTRSI6Vgftjdad8Y"
              "wsDhOTTfdDdKvXvhz6FOG"
              "3bLtz5MBx3fXf4UD2OKkj4"
            ]
          }
        }
      ) {
        nodes {
          id
          url
          title
          width
          height
        }
      }
      brandsDE: allContentfulAsset(
        filter: {
          contentful_id: {
            in: [
              "1XNyEQpWwDrpHcgDlHvtHC"
              "54QMQihp2BlOeQiiBgsdX6"
              "2HolWzIuAgc4ilyCWYLYQZ"
              "6XxGRH0SvoHtpMsaV1bPrb"
              "2RcuddBr6AKHSYhIPriJV1"
            ]
          }
        }
      ) {
        nodes {
          id
          url
          title
          width
          height
        }
      }
    }
  `);

  const brandsArray =
    brandsList !== undefined
      ? brandsList
      : language == 'de'
      ? pageQuery.brandsDE.nodes
      : pageQuery.brandsEN.nodes;

  return (
    <div
      className={
        classNames(
          'grid grid-cols-2 justify-center items-center sm:grid-cols-4 lg:flex md:justify-between '
        ) + className
      }
    >
      {brandsArray &&
        brandsArray?.map((brand, index) => {
          return (
            <div
              key={index}
              aria-hidden={true}
              className={classNames(
                'flex my-7 mx-auto lg:my-10 justify-center items-center',
                {
                  'w-auto': !center,
                  'cursor-pointer': brand?.onClick,
                  grayscale: brand?.filter && !brand?.onClick,
                  'grayscale-hover': brand?.filter && brand?.onClick,
                }
              )}
              onClick={brand?.onClick}
            >
              <img
                className="max-w-[150px] w-full"
                src={brand.src !== undefined ? brand.src : brand.url}
                alt={brand.title !== undefined ? brand.title : 'brand'}
              />
            </div>
          );
        })}
    </div>
  );
};

export default Brands;
